import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { LOGIN } from '../graphql/queries'
import './Login.css'

function Login({ onLogin }) {
  const [formData, setFormData] = useState({
    usuario: '',
    password: ''
  })
  const [error, setError] = useState('')

  const [login, { loading }] = useMutation(LOGIN, {
    onCompleted: (data) => {
      onLogin(data.login.token, data.login.usuario)
    },
    onError: (error) => {
      setError(error.message || 'Error al iniciar sesión')
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    setError('')

    if (!formData.usuario || !formData.password) {
      setError('Por favor complete todos los campos')
      return
    }

    login({
      variables: {
        usuario: formData.usuario,
        password: formData.password
      }
    })
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">Factufy</h1>
          <p className="login-subtitle">Sistema de Gestión de Licencias</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Usuario</label>
            <input
              type="text"
              name="usuario"
              value={formData.usuario}
              onChange={handleChange}
              className="form-input"
              placeholder="Ingrese su usuario"
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-input"
              placeholder="Ingrese su contraseña"
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg login-btn"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="login-footer">
          <p>Usuario por defecto: <strong>admin</strong></p>
          <p>Contraseña: <strong>Admin123!</strong></p>
        </div>
      </div>
    </div>
  )
}

export default Login
